import React from "react";
import { Heart, ShieldCheck } from "lucide-react";
import { AUTOBOOKS_URL, DONATE_TAGLINE } from "@/lib/config";

const VARIANTS = {
  primary:
    "bg-[#E94F9A] text-white hover:bg-[#D13D86] shadow-md hover:shadow-lg hover:-translate-y-0.5 px-6 py-2.5 text-xs",
  large:
    "bg-[#E94F9A] text-white hover:bg-[#D13D86] shadow-lg hover:-translate-y-0.5 px-10 py-4 text-sm",
  soft:
    "bg-[#E94F9A] hover:bg-[#D13D86] text-white px-4 sm:px-5 py-2.5 text-xs",
  outline:
    "border border-[#4B1E5A] text-[#4B1E5A] hover:bg-[#FFF5F9] px-6 py-2.5 text-xs",
};

// Reusable Donate CTA — links securely to AutoBooks, opens in a new tab,
// marked secure, with a subtle hover message. Used site-wide.
export const DonateButton = ({
  label = "Donate",
  variant = "primary",
  className = "",
  showTagline = true,
  showIcon = true,
  testId = "donate-btn",
}) => {
  return (
    <a
      href={AUTOBOOKS_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label="Donate securely via AutoBooks"
      className={`group relative inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all whitespace-nowrap ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
    >
      {showIcon && <Heart className="h-4 w-4" />}
      <span>{label}</span>
      {showTagline && (
        <span className="pointer-events-none absolute bottom-full left-1/2 mb-3 -translate-x-1/2 w-60 rounded-2xl bg-[#4B1E5A] px-4 py-3 text-center text-[11px] font-normal leading-relaxed text-white opacity-0 shadow-xl transition-all duration-300 group-hover:opacity-100 group-hover:mb-4 z-50">
          <span className="flex items-center justify-center gap-1.5 mb-1 text-[#C8A96A] font-semibold uppercase tracking-wider text-[10px]">
            <ShieldCheck className="h-3 w-3" /> Secure Giving
          </span>
          {DONATE_TAGLINE}
        </span>
      )}
    </a>
  );
};
